// extracted by mini-css-extract-plugin
export default {"product_images":"ProductImages_product_images__83RGc","img":"ProductImages_img__FS7E+"};